var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 149l256 84v18L0 167z",
    fill: "#e2e3e5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 149l-256 84v18l256-84z",
    fill: "#afb7ba"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 167l256 83.94V502L0 420.95z",
    fill: "#f0f2f4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512 167l-256 83.93V502l256-81.06z",
    fill: "#d1d5d8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 87l256 83.08v62.8L0 149z",
    fill: "#3375d6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M512 87l-256 83.11v62.8L512 149z",
    fill: "#2457a3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 87L256 3v167L0 87zM512 87L256 3v167l256-83z",
    fill: "#4f87db"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M176.19 46.39l199.89 66-48.91 16L130 62z",
    fill: "#2457a3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M173 0l146 43.37v81.45L173 76V0z",
    fill: "#fcfcfc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f3c29c067021ebf447cd4bee4826dd08.svg";
export { ForwardRef as ReactComponent };